export default {
  namespaced: true,

  state: {
    isLoading: true,
    recordsIsLoading: true,
    list: [],
    reverseList: [],
    fixedReverseList: [],
    updateKey: 0,
    formKey: 0,
    recordKey: 0,
    selected: [],
    current: false,
    active: [],
    currentRecords: [],
    currentReverse: [],
    hasRecordsData: false,
    reverseSet: true,
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    RECORDS_IS_LOADING(state, bool) {
      state.recordsIsLoading = bool;
    },

    SET(state, services) {
      state.list = services;
    },

    SET_REVERSE_DNS(state, services) {
      state.reverseList = services;
    },

    SET_FIXED_REVERSE_DNS(state, services) {
      state.fixedReverseList = services;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    UPDATE_FORM_KEY(state) {
      state.formKey += 1;
    },

    UPDATE(state, resource) {
        const item = state.list.find(item => item.id === resource.id);
        Object.assign(item, resource);
    },

    UPDATE_RECORD(state, resource) {
        const item = state.currentRecords.find(item => item.id === resource.id);
        Object.assign(item, resource);
    },

    SET_ACTIVE(state, services) {
      state.active = services;
    },

    RECORD_KEY(state) {
      state.recordKey += 1;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    SET_CURRENT(state, services) {
      state.current = services;
    },

    SET_CURRENT_REVERSE(state, services) {
      state.currentReverse = services;
    },

    SET_RECORDS(state, services) {
      state.currentRecords = services;
    },

    ADD_RECORDS(state, services) {
      state.currentRecords.push(services);
    },

    HAS_RECORDS_DATA(state, bool) {
      state.hasRecordsData = bool;
    },

    REVERSE_SET(state, bool) {
      state.reverseSet = bool;
    },
  },

  actions: {
    SET(context, services) {
      context.commit('SET', services);
    },

    SET_CURRENT(context, services) {
      context.commit('SET_CURRENT', services);
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },
  }
}
